import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue';
import { renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createVNode as _createVNode } from "vue";
const _hoisted_1 = { class: "website-selector" };
const _hoisted_2 = { key: 0 };
import { computed, useSlots, } from "vue";
import OneDeskMultiSelect from "@/components/atoms/OneDeskMultiSelect.vue";
import { useStore } from "@/shared/composables/useStore";
import { ReferenceValuesTypes } from "@/store/modules/reference-values/types";
export default /*#__PURE__*/ _defineComponent({
    __name: 'MarketsMultiSelector',
    props: /*#__PURE__*/ _mergeModels({
        filter: { type: Boolean, default: true },
        loading: { type: Boolean, default: false },
        optionIsValue: { type: Boolean, default: false },
        placeholder: { default: "Select Markets" }
    }, {
        "modelValue": { default: [] },
        "modelModifiers": {},
    }),
    emits: ["update:modelValue"],
    setup(__props) {
        const model = _useModel(__props, "modelValue");
        const props = __props;
        const slots = useSlots();
        const store = useStore();
        const markets = computed(() => store.getters[ReferenceValuesTypes.MARKETS]);
        const hasLabelSlot = computed(() => !!slots.label);
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createVNode(OneDeskMultiSelect, {
                    "data-testid": "markets-multi-selector",
                    modelValue: model.value,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((model).value = $event)),
                    options: markets.value,
                    "linera-label": false,
                    "option-label": "label",
                    "option-value": props.optionIsValue ? 'label' : 'id',
                    "force-selection": "",
                    filter: props.filter,
                    "show-counter": true,
                    placeholder: props.placeholder,
                    loading: props.loading
                }, {
                    label: _withCtx(() => [
                        (hasLabelSlot.value)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                                _renderSlot(_ctx.$slots, "label")
                            ]))
                            : _createCommentVNode("", true)
                    ]),
                    _: 3
                }, 8, ["modelValue", "options", "option-value", "filter", "placeholder", "loading"])
            ]));
        };
    }
});
